import React, { Fragment } from 'react';
import axios from 'axios';

let _wording = null;

export const loadWordingJson = url => {
  return new Promise((resolve, reject) => {
    axios.get(url)
      .then( res => {
        _wording = res.data;
        resolve(res.data);
      })
      .catch( err => {
        reject(err);
      })
  });
}

export const getWording = fieldName => {
  return _wording?.[fieldName] || fieldName;
}

export const nl2br = (str) => {
  if (str === null || str === undefined) return '';

  if (navigator.userAgent.match("MSIE") || navigator.userAgent.match(".NET") ) {
    return str;
  } 
  
  str = str.replace?.(/\\n/g, '\n');
  return str?.split?.('\n').map((item, key) => {
    return <Fragment key={key}>{item}<br/></Fragment>
  });
}

export const nl2p = str => {
  if (str === null || str === undefined) return '';
  str = str.replace?.(/\\n/g, '\n');

  return str?.split?.('\n').map((item, key) => {
    item = item !== '' ? item : <br/>;
    return <p key={key}>{item}</p> ;
  });
}